import { all } from "redux-saga/effects";

import {
  loadAllSolutionsSaga,
  loadSingleSolutionSaga,
} from "@modules/Solution/SolutionsList/SolutionsList.saga";
import getTransportQuotationsSaga from "@modules/TransportQuotations/TransportQuotationsList/TransportQuotations.saga";
import {
  loadAllAnalyticalNotesSaga,
  loadSingleAnalyticalNoteSaga,
} from "@modules/AnalyticalNotes/AnalyticalNotesList/AnalyticalNotesList.saga";
import {
  loadAllMeetingReportsSaga,
  loadSingleMeetingReportSaga,
} from "@modules/MeetingReports/MeetingReportsList/MeetingReportsList.saga";
import {
  loadAllContactSaga,
  loadSingleContactSaga,
} from "@modules/Contact/ContactList/ContactList.saga";

import {
  loadAllRelatedContactSaga,
  loadSingleRelatedContactSaga,
} from "@modules/RelatedContact/RelatedContactList/RelatedContactList.saga";

import {
  loadAllProductsSaga,
  loadSingleProductSaga,
} from "@modules/Products/ProductsList/ProductsList.saga";

import {
  loadAllCenterProductsSaga,
  loadSingleCenterProductSaga,
} from "@modules/CenterProducts/CenterProductsList/CenterProductsList.saga";

import {
  loadAllCenterSaga,
  loadSingleCenterSaga,
} from "@modules/Center/CenterList/CenterList.saga";

import {
  loadAllCenterProductPriceSaga,
  loadSingleCenterProductPriceSaga,
} from "@modules/CenterProductPrice/PriceList/PriceList.saga";

import {
  loadAllCompaniesSaga,
  loadSingleCompanySaga,
} from "@modules/Company/CompanyList/CompanyList.saga";

import {
  loadAllWarehouseSaga,
  loadSingleWarehouseSaga,
} from "@modules/Warehouse/WarehouseList/WarehouseList.saga";

import {
  loadAllSiteSaga,
  loadSingleSiteSaga,
} from "@modules/Site/SiteList/SiteList.saga";

import {
  loadAllEnquiriesSaga,
  loadSingleEnquirySaga,
} from "@modules/Enquiry/EnquiryList/EnquiryList.saga";

import {
  loadAllSellingPricesSaga,
  loadSingleSellingPriceSaga,
} from "@modules/SellingPrice/SellingPricesList/SellingPricesList.saga";

import {
  loadAllQuotesSaga,
  loadSingleQuoteSaga,
} from "@modules/Quote/QuoteList/QuoteList.saga";

import {
  loadAllLeadSaga,
  loadSingleLeadSaga,
} from "@modules/Lead/LeadList/LeadList.saga";

const rootSaga = function* () {
  yield all([
    loadAllSolutionsSaga(),
    loadSingleSolutionSaga(),
    getTransportQuotationsSaga(),
    loadAllAnalyticalNotesSaga(),
    loadSingleAnalyticalNoteSaga(),
    loadAllMeetingReportsSaga(),
    loadSingleMeetingReportSaga(),
    loadAllContactSaga(),
    loadSingleContactSaga(),
    loadAllRelatedContactSaga(),
    loadSingleRelatedContactSaga(),
    loadAllProductsSaga(),
    loadSingleProductSaga(),
    loadAllCenterProductsSaga(),
    loadSingleCenterProductSaga(),
    loadAllCenterProductPriceSaga(),
    loadSingleCenterProductPriceSaga(),
    loadAllCompaniesSaga(),
    loadSingleCompanySaga(),
    loadAllCenterSaga(),
    loadSingleCenterSaga(),
    loadAllWarehouseSaga(),
    loadSingleWarehouseSaga(),
    loadAllSiteSaga(),
    loadSingleSiteSaga(),
    loadAllEnquiriesSaga(),
    loadSingleEnquirySaga(),
    loadAllSellingPricesSaga(),
    loadSingleSellingPriceSaga(),
    loadAllQuotesSaga(),
    loadSingleQuoteSaga(),
    loadAllLeadSaga(),
    loadSingleLeadSaga(),
  ]);
};

export default rootSaga;
